<hrt-table
  [tableId]="tableId"
  [columnDefinitions]="columnDefinitions"
  [tableData]="tableData"
  [totalCount]="totalCount"
  (searchText)="updateSearchTerm($event)"
  (rowClicked)="rowClicked($event)"
>
</hrt-table>
